export const TARGET_SELECTION_TABLE = {
  columns: [
    { name: 'TargetName', title: 'Target Name' },
    { name: 'TargetPath', title: 'Target Path' },
    { name: 'TargetFrequency', title: 'Frequency' },
    { name: 'Ingredients', title: 'Ingredients' },
    { name: 'coreConfiguration', title: 'Core Configuration' },
    { name: 'emulationTech', title: 'Emulation Technology' },
    { name: 'rtlCores', title: 'RTL Cores' },
  ],
  filteringStateColumnExtensions: [
    { columnName: 'targetName', filteringEnabled: false },
    { columnName: 'frequency', filteringEnabled: false },
    { columnName: 'ingridients', filteringEnabled: false },
    { columnName: 'coreConfiguration', filteringEnabled: false },
    { columnName: 'boardTech', filteringEnabled: false },
  ],
  tableColumnExtensions: [
    { columnName: 'TargetName', width: '12rem' },
    { columnName: 'TargetPath', width: 'auto' },
    { columnName: 'TargetFrequency', width: '6rem' },
    { columnName: 'Ingredients', width: '12rem' },
    { columnName: 'coreConfiguration', width: '10rem' },
    { columnName: 'emulationTech', width: '10rem' },
    { columnName: 'rtlCores', width: '6rem' },
  ],
  tableTitle: 'Target Selection',
  tableKey: 'targetSelection',
};
